// ─────────────────────────────────────────────────────────────────
//  BuildPro · Catalogue  (345 partidas)
//  File: modules/buildpro/catalogue.ts
// ─────────────────────────────────────────────────────────────────
import type { BuildProMode } from './types';

export interface CatalogueItem {
  id: string;
  cod: string;
  label: string;
  ud: string;
  p: number;
}

export interface CatalogueCategory {
  id: string;
  icon: string;
  label: string;
  color: string;
  items: CatalogueItem[];
}

// ── AI output key → item id ───────────────────────────────────────
export const AI_KEY_MAP: Record<string, string> = {
  // REFORMA
  D1:'d1',D2:'d2',D3:'d3',D4:'d4',D5:'d5',D6:'d6',D7:'d7',D8:'d8',D11:'d11',
  T1:'t1',T2:'t2',T3:'t3',T4:'t4',T5:'t5',T6:'t6',T7:'t7',T9:'t9',
  C1:'c1',C2:'c2',C3:'c3',C4:'c4',C5:'c5',C6:'c6',C7:'c7',C9:'c9',C10:'c10',C11:'c11',
  K1:'k1',K2:'k2',K3:'k3',K3B:'k3b',K4:'k4',K5:'k5',K5B:'k5b',K6:'k6',K7:'k7',K8:'k8',K9:'k9',K10:'k10',K11:'k11',K12:'k12',K13:'k13',
  B1:'b1',B2:'b2',B3:'b3',B3B:'b3b',B3C:'b3c',B4:'b4',B5:'b5',B6:'b6',B6B:'b6b',B7:'b7',B8:'b8',B9:'b9',B10:'b10',B10B:'b10b',B11:'b11',B12:'b12',B13:'b13',B14:'b14',B16:'b16',
  H1:'h1',H1B:'h1b',H2:'h2',H4:'h4',H5:'h5',H6:'h6',H7:'h7',H8:'h8',H8B:'h8b',H8C:'h8c',H9:'h9',H9B:'h9b',H11:'h11',H12:'h12',H14:'h14',
  F1:'f1',F2:'f2',F3:'f3',F4:'f4',F5:'f5',F6:'f6',F7:'f7',F9:'f9',F10:'f10',F11:'f11',F12:'f12',
  E1:'e1',E2:'e2',E3:'e3',E4:'e4',E5:'e5',E6:'e6',E7:'e7',E7B:'e7b',E8:'e8',E8B:'e8b',E8C:'e8c',E9:'e9',E10:'e10',E10B:'e10b',E10C:'e10c',E10D:'e10d',E11:'e11',E12:'e12',E12B:'e12b',E12C:'e12c',E12D:'e12d',E13:'e13',E14:'e14',E15:'e15',E16:'e16',E18:'e18',
  A1:'a1',A1B:'a1b',A1C:'a1c',A1D:'a1d',A1E:'a1e',A2:'a2',A3:'a3',A4:'a4',A4B:'a4b',A5:'a5',A5B:'a5b',A5C:'a5c',A5D:'a5d',A6:'a6',A7:'a7',A7B:'a7b',A8:'a8',A9:'a9',A10:'a10',
  // OBRA NUEVA
  MV1:'mv1',MV2:'mv2',MV3:'mv3',MV4:'mv4',MV5:'mv5',MV6:'mv6',MV7:'mv7',
  CI1:'ci1',CI2:'ci2',CI3:'ci3',CI4:'ci4',CI5:'ci5',CI7:'ci7',CI8:'ci8',CI9:'ci9',CI10:'ci10',CI11:'ci11',CI12:'ci12',CI13:'ci13',CI14:'ci14',
  CE1:'ce1',CE2:'ce2',CE3:'ce3',CE4:'ce4',CE5:'ce5',CE6:'ce6',CE7:'ce7',CE8:'ce8',CE9:'ce9',CE10:'ce10',CE11:'ce11',CE12:'ce12',CE13:'ce13',CE14:'ce14',CE15:'ce15',CE16:'ce16',
  CP1:'cp1',CP2:'cp2',CP3:'cp3',CP4:'cp4',CP5:'cp5',CP6:'cp6',CP7:'cp7',CP8:'cp8',CP9:'cp9',CP10:'cp10',CP11:'cp11',
  IN1:'in1',IN2:'in2',IN3:'in3',IN4:'in4',IN5:'in5',IN6:'in6',IN7:'in7',IN8:'in8',IN9:'in9',IN10:'in10',IN11:'in11',IN12:'in12',IN13:'in13',IN14:'in14',IN15:'in15',IN16:'in16',IN17:'in17',IN18:'in18',IN19:'in19',IN20:'in20',
  BN1:'bn1',BN2:'bn2',BN3:'bn3',BN4:'bn4',BN5:'bn5',BN6:'bn6',BN7:'bn7',BN8:'bn8',BN9:'bn9',
  AC1:'ac1',AC2:'ac2',AC3:'ac3',AC4:'ac4',AC5:'ac5',AC6:'ac6',AC7:'ac7',AC8:'ac8',AC9:'ac9',AC11:'ac11',
  // EXTERIOR
  XM1:'xm1',XM2:'xm2',XM3:'xm3',XM4:'xm4',XM5:'xm5',
  V1:'v1',V2:'v2',V3:'v3',V4:'v4',V5:'v5',V6:'v6',V7:'v7',V8:'v8',V9:'v9',V10:'v10',V11:'v11',V12:'v12',V13:'v13',
  P1:'p1',P2:'p2',P3:'p3',P4:'p4',P5:'p5',P6:'p6',P7:'p7',P8:'p8',P9:'p9',P10:'p10',P11:'p11',
  PV1:'pv1',PV2:'pv2',PV3:'pv3',PV4:'pv4',PV5:'pv5',PV6:'pv6',PV7:'pv7',PV8:'pv8',PV9:'pv9',PV10:'pv10',
  PS1:'ps1',PS2:'ps2',PS3:'ps3',PS4:'ps4',PS5:'ps5',PS6:'ps6',PS7:'ps7',PS8:'ps8',PS9:'ps9',PS10:'ps10',PS11:'ps11',PS12:'ps12',PS13:'ps13',PS14:'ps14',
  J1:'j1',J2:'j2',J3:'j3',J4:'j4',J5:'j5',J6:'j6',J7:'j7',J8:'j8',J9:'j9',J10:'j10',J11:'j11',J12:'j12',J13:'j13',J14:'j14',J15:'j15',J16:'j16',J17:'j17',J18:'j18',J19:'j19',J20:'j20',J21:'j21',
  BQ1:'bq1',BQ2:'bq2',BQ3:'bq3',BQ4:'bq4',BQ5:'bq5',BQ6:'bq6',BQ7:'bq7',BQ8:'bq8',BQ9:'bq9',BQ10:'bq10',BQ11:'bq11',BQ12:'bq12',BQ13:'bq13',BQ14:'bq14',BQ15:'bq15',BQ16:'bq16',
  IL1:'il1',IL2:'il2',IL3:'il3',IL4:'il4',IL5:'il5',IL6:'il6',IL7:'il7',IL8:'il8',IL9:'il9',
  DR1:'dr1',DR2:'dr2',DR3:'dr3',DR4:'dr4',DR5:'dr5',DR6:'dr6',DR7:'dr7',DR8:'dr8',DR9:'dr9',DR10:'dr10',DR11:'dr11',DR12:'dr12',
};

// ── Helpers ───────────────────────────────────────────────────────
export function getCatalogue(mode: BuildProMode): CatalogueCategory[] {
  switch (mode) {
    case 'reforma':  return CATS_REFORMA;
    case 'nueva':    return CATS_NUEVA;
    case 'exterior': return CATS_EXTERIOR;
  }
}

export function getAllItemsMap(): Map<string, CatalogueItem & { categoryId: string; categoryLabel: string; mode: BuildProMode }> {
  const map = new Map();
  for (const mode of ['reforma', 'nueva', 'exterior'] as BuildProMode[]) {
    for (const cat of getCatalogue(mode)) {
      for (const item of cat.items) {
        map.set(item.id, { ...item, categoryId: cat.id, categoryLabel: cat.label, mode });
      }
    }
  }
  return map;
}

// ── REFORMA (132 items) ───────────────────────────────────────────
export const CATS_REFORMA: CatalogueCategory[] = [
  {id:"dem",icon:"🔨",label:"Demolición",color:"#F87171",items:[
    {id:"d1",cod:"DEM001",label:"Tabique a derribar",ud:"ml",p:45},
    {id:"d2",cod:"DEM002",label:"Puerta/marco a quitar",ud:"ud",p:85},
    {id:"d3",cod:"DEM003",label:"Ventana/balconera a quitar",ud:"ud",p:90},
    {id:"d4",cod:"DEM004",label:"Pavimento a levantar",ud:"m²",p:12},
    {id:"d5",cod:"DEM005",label:"Alicatado a picar",ud:"m²",p:8},
    {id:"d6",cod:"DEM006",label:"Sanitarios a retirar",ud:"ud",p:95},
    {id:"d7",cod:"DEM007",label:"Falso techo a demoler",ud:"m²",p:18},
    {id:"d8",cod:"DEM008",label:"Cocina a retirar completa",ud:"ud",p:320},
    {id:"d11",cod:"DEM011",label:"Gestión y transporte escombros",ud:"m³",p:65},
  ]},
  {id:"tab",icon:"🧱",label:"Tabiquería",color:"#FB923C",items:[
    {id:"t1",cod:"TAB001",label:"Tabique ladrillo hueco 7cm",ud:"m²",p:42},
    {id:"t2",cod:"TAB002",label:"Tabique ladrillo hueco 9cm",ud:"m²",p:48},
    {id:"t3",cod:"TAB003",label:"Tabique cartón-yeso simple",ud:"m²",p:38},
    {id:"t4",cod:"TAB004",label:"Tabique cartón-yeso doble",ud:"m²",p:52},
    {id:"t5",cod:"TAB005",label:"Trasdosado térmico/acústico",ud:"m²",p:35},
    {id:"t6",cod:"TAB006",label:"Regatas para instalaciones",ud:"ml",p:12},
    {id:"t7",cod:"TAB007",label:"Tabique obra húmeda baño",ud:"m²",p:58},
    {id:"t9",cod:"TAB009",label:"Refuerzo estructural pilar/viga",ud:"ud",p:480},
  ]},
  {id:"car",icon:"🚪",label:"Carpintería",color:"#34D399",items:[
    {id:"c1",cod:"CAR001",label:"Puerta interior paso",ud:"ud",p:320},
    {id:"c2",cod:"CAR002",label:"Puerta corredera",ud:"ud",p:480},
    {id:"c3",cod:"CAR003",label:"Puerta entrada blindada",ud:"ud",p:1200},
    {id:"c4",cod:"CAR004",label:"Ventana PVC/aluminio 1 hoja",ud:"ud",p:420},
    {id:"c5",cod:"CAR005",label:"Ventana PVC/aluminio 2 hojas",ud:"ud",p:520},
    {id:"c6",cod:"CAR006",label:"Balconera PVC/aluminio",ud:"ud",p:680},
    {id:"c7",cod:"CAR007",label:"Armario empotrado a medida",ud:"ml",p:280},
    {id:"c9",cod:"CAR009",label:"Ventana de tejado tipo Velux",ud:"ud",p:950},
    {id:"c10",cod:"CAR010",label:"Puerta corredera de cristal",ud:"ud",p:1100},
    {id:"c11",cod:"CAR011",label:"Persiana motorizada",ud:"ud",p:380},
  ]},
  {id:"coc",icon:"🍳",label:"Cocina",color:"#FBBF24",items:[
    {id:"k1",cod:"COC001",label:"Módulos bajos",ud:"ml",p:620},
    {id:"k2",cod:"COC002",label:"Módulos altos",ud:"ml",p:480},
    {id:"k3",cod:"COC003",label:"Encimera silestone/granito",ud:"ml",p:350},
    {id:"k3b",cod:"COC003B",label:"Encimera laminada/postformada",ud:"ml",p:180},
    {id:"k4",cod:"COC004",label:"Horno empotrado",ud:"ud",p:680},
    {id:"k5",cod:"COC005",label:"Placa de inducción",ud:"ud",p:520},
    {id:"k5b",cod:"COC005B",label:"Placa de gas",ud:"ud",p:320},
    {id:"k6",cod:"COC006",label:"Campana extractora",ud:"ud",p:380},
    {id:"k7",cod:"COC007",label:"Lavavajillas",ud:"ud",p:520},
    {id:"k8",cod:"COC008",label:"Frigorífico",ud:"ud",p:890},
    {id:"k9",cod:"COC009",label:"Fregadero + grifería",ud:"ud",p:320},
    {id:"k10",cod:"COC010",label:"Microondas empotrado",ud:"ud",p:380},
    {id:"k11",cod:"COC011",label:"Lavadora/secadora instalación",ud:"ud",p:180},
    {id:"k12",cod:"COC012",label:"Módulo columna/despensa",ud:"ud",p:420},
    {id:"k13",cod:"COC013",label:"Isla central cocina",ud:"ud",p:1800},
  ]},
  {id:"ban",icon:"🚿",label:"Baños",color:"#60A5FA",items:[
    {id:"b1",cod:"BAN001",label:"Inodoro suspendido + cisterna empotrada",ud:"ud",p:680},
    {id:"b2",cod:"BAN002",label:"Inodoro a suelo",ud:"ud",p:220},
    {id:"b3",cod:"BAN003",label:"Lavabo sobre mueble",ud:"ud",p:220},
    {id:"b3b",cod:"BAN003B",label:"Lavabo suspendido",ud:"ud",p:180},
    {id:"b3c",cod:"BAN003C",label:"Lavabo doble",ud:"ud",p:380},
    {id:"b4",cod:"BAN004",label:"Bidé",ud:"ud",p:180},
    {id:"b5",cod:"BAN005",label:"Plato ducha resina/obra",ud:"ud",p:380},
    {id:"b6",cod:"BAN006",label:"Bañera acrílica",ud:"ud",p:520},
    {id:"b6b",cod:"BAN006B",label:"Bañera exenta/freestanding",ud:"ud",p:1400},
    {id:"b7",cod:"BAN007",label:"Mampara ducha fija",ud:"ud",p:280},
    {id:"b8",cod:"BAN008",label:"Mampara abatible/corredera",ud:"ud",p:420},
    {id:"b9",cod:"BAN009",label:"Grifería lavabo monomando",ud:"ud",p:180},
    {id:"b10",cod:"BAN010",label:"Grifería ducha termostática",ud:"ud",p:320},
    {id:"b10b",cod:"BAN010B",label:"Grifería ducha estándar",ud:"ud",p:180},
    {id:"b11",cod:"BAN011",label:"Columna de ducha",ud:"ud",p:480},
    {id:"b12",cod:"BAN012",label:"Mueble baño + espejo/botiquín",ud:"ud",p:780},
    {id:"b13",cod:"BAN013",label:"Toallero eléctrico",ud:"ud",p:380},
    {id:"b14",cod:"BAN014",label:"Extractor baño + tubo",ud:"ud",p:180},
    {id:"b16",cod:"BAN016",label:"Accesorios baño",ud:"ud",p:45},
  ]},
  {id:"cal",icon:"🌡️",label:"Calefacción / Clima",color:"#FB923C",items:[
    {id:"h1",cod:"CAL001",label:"Caldera condensación gas",ud:"ud",p:2800},
    {id:"h1b",cod:"CAL001B",label:"Caldera biomasa/pellets",ud:"ud",p:4200},
    {id:"h2",cod:"CAL002",label:"Aerotermia exterior+interior",ud:"ud",p:5500},
    {id:"h4",cod:"CAL004",label:"Radiador acero (por elemento)",ud:"elem",p:28},
    {id:"h5",cod:"CAL005",label:"Toallero baño (por elemento)",ud:"elem",p:35},
    {id:"h6",cod:"CAL006",label:"Suelo radiante eléctrico",ud:"m²",p:28},
    {id:"h7",cod:"CAL007",label:"Suelo radiante hidráulico",ud:"m²",p:42},
    {id:"h8",cod:"CAL008",label:"Split 1x1 pared int+ext",ud:"ud",p:1200},
    {id:"h8b",cod:"CAL008B",label:"Multi-split unidad exterior",ud:"ud",p:1800},
    {id:"h8c",cod:"CAL008C",label:"Multi-split unidad interior adicional",ud:"ud",p:680},
    {id:"h9",cod:"CAL009",label:"Conducto centralizado unidad ext.",ud:"ud",p:2800},
    {id:"h9b",cod:"CAL009B",label:"Conducto difusor/rejilla",ud:"ud",p:180},
    {id:"h11",cod:"CAL011",label:"Termostato programable/smart",ud:"ud",p:120},
    {id:"h12",cod:"CAL012",label:"Válvula termostática radiador",ud:"ud",p:35},
    {id:"h14",cod:"CAL014",label:"Depósito acumulador ACS",ud:"ud",p:650},
  ]},
  {id:"fon",icon:"🔧",label:"Fontanería",color:"#38BDF8",items:[
    {id:"f1",cod:"FON001",label:"Tubería agua fría multicapa/PEX",ud:"ml",p:28},
    {id:"f2",cod:"FON002",label:"Tubería agua caliente aislada",ud:"ml",p:32},
    {id:"f3",cod:"FON003",label:"Bajante/desagüe PVC",ud:"ml",p:22},
    {id:"f4",cod:"FON004",label:"Bote sifónico",ud:"ud",p:45},
    {id:"f5",cod:"FON005",label:"Punto de consumo nuevo",ud:"ud",p:180},
    {id:"f6",cod:"FON006",label:"Válvula de corte esfera",ud:"ud",p:38},
    {id:"f7",cod:"FON007",label:"Llave de paso general + armario",ud:"ud",p:280},
    {id:"f9",cod:"FON009",label:"Calentador eléctrico",ud:"ud",p:380},
    {id:"f10",cod:"FON010",label:"Calentador gas instantáneo",ud:"ud",p:480},
    {id:"f11",cod:"FON011",label:"Filtro/descalcificador",ud:"ud",p:580},
    {id:"f12",cod:"FON012",label:"Instalación gas tubería+llave",ud:"ml",p:38},
  ]},
  {id:"ele",icon:"⚡",label:"Electricidad",color:"#FCD34D",items:[
    {id:"e1",cod:"ELE001",label:"Cuadro eléctrico ICP+diferencial+PIAs",ud:"ud",p:850},
    {id:"e2",cod:"ELE002",label:"Circuito iluminación general",ud:"ud",p:180},
    {id:"e3",cod:"ELE003",label:"Circuito enchufes 16A",ud:"ud",p:160},
    {id:"e4",cod:"ELE004",label:"Circuito cocina 20A",ud:"ud",p:180},
    {id:"e5",cod:"ELE005",label:"Circuito horno/lavavajillas",ud:"ud",p:160},
    {id:"e6",cod:"ELE006",label:"Circuito lavadora/secadora",ud:"ud",p:160},
    {id:"e7",cod:"ELE007",label:"Circuito aire acondicionado",ud:"ud",p:160},
    {id:"e7b",cod:"ELE007B",label:"Circuito recarga VE",ud:"ud",p:220},
    {id:"e8",cod:"ELE008",label:"Punto de luz empotrado",ud:"ud",p:95},
    {id:"e8b",cod:"ELE008B",label:"Downlight LED empotrado",ud:"ud",p:65},
    {id:"e8c",cod:"ELE008C",label:"Luz de emergencia",ud:"ud",p:85},
    {id:"e9",cod:"ELE009",label:"Enchufe schuko doble",ud:"ud",p:55},
    {id:"e10",cod:"ELE010",label:"Enchufe schuko simple",ud:"ud",p:45},
    {id:"e10b",cod:"ELE010B",label:"Enchufe con USB",ud:"ud",p:65},
    {id:"e10c",cod:"ELE010C",label:"Enchufe TV/SAT",ud:"ud",p:48},
    {id:"e10d",cod:"ELE010D",label:"Enchufe RJ45 datos",ud:"ud",p:52},
    {id:"e11",cod:"ELE011",label:"Enchufe exterior estanco",ud:"ud",p:68},
    {id:"e12",cod:"ELE012",label:"Interruptor/conmutador",ud:"ud",p:38},
    {id:"e12b",cod:"ELE012B",label:"Cruzamiento 3+ puntos",ud:"ud",p:48},
    {id:"e12c",cod:"ELE012C",label:"Regulador/dimmer",ud:"ud",p:85},
    {id:"e12d",cod:"ELE012D",label:"Detector presencia/temporizado",ud:"ud",p:95},
    {id:"e13",cod:"ELE013",label:"Detector de humo",ud:"ud",p:65},
    {id:"e14",cod:"ELE014",label:"Detector CO/gas",ud:"ud",p:85},
    {id:"e15",cod:"ELE015",label:"Timbre/videoportero",ud:"ud",p:320},
    {id:"e16",cod:"ELE016",label:"Cableado general tubo+cable",ud:"ml",p:6},
    {id:"e18",cod:"ELE018",label:"Toma de tierra completa",ud:"ud",p:380},
  ]},
  {id:"aca",icon:"🎨",label:"Acabados",color:"#A78BFA",items:[
    {id:"a1",cod:"ACA001",label:"Pavimento tarima flotante",ud:"m²",p:38},
    {id:"a1b",cod:"ACA001B",label:"Pavimento tarima maciza",ud:"m²",p:65},
    {id:"a1c",cod:"ACA001C",label:"Pavimento baldosa cerámica/gres",ud:"m²",p:42},
    {id:"a1d",cod:"ACA001D",label:"Pavimento microcemento",ud:"m²",p:85},
    {id:"a1e",cod:"ACA001E",label:"Pavimento mármol/piedra",ud:"m²",p:120},
    {id:"a2",cod:"ACA002",label:"Rodapiés",ud:"ml",p:14},
    {id:"a3",cod:"ACA003",label:"Alicatado suelo",ud:"m²",p:38},
    {id:"a4",cod:"ACA004",label:"Alicatado paredes",ud:"m²",p:42},
    {id:"a4b",cod:"ACA004B",label:"Revestimiento microcemento paredes",ud:"m²",p:90},
    {id:"a5",cod:"ACA005",label:"Pintura paredes imprimación+2 manos",ud:"m²",p:9},
    {id:"a5b",cod:"ACA005B",label:"Pintura lavable premium",ud:"m²",p:13},
    {id:"a5c",cod:"ACA005C",label:"Gotelé proyectado",ud:"m²",p:8},
    {id:"a5d",cod:"ACA005D",label:"Papel pintado",ud:"m²",p:18},
    {id:"a6",cod:"ACA006",label:"Pintura techo",ud:"m²",p:9},
    {id:"a7",cod:"ACA007",label:"Falso techo cartón-yeso",ud:"m²",p:48},
    {id:"a7b",cod:"ACA007B",label:"Falso techo continuo pladur",ud:"m²",p:55},
    {id:"a8",cod:"ACA008",label:"Nivelación suelo autonivelante",ud:"m²",p:8},
    {id:"a9",cod:"ACA009",label:"Impermeabilización baño/terraza",ud:"m²",p:22},
    {id:"a10",cod:"ACA010",label:"Zócalo madera/MDF",ud:"ml",p:22},
  ]},
];

// ── OBRA NUEVA (86 items) ─────────────────────────────────────────
export const CATS_NUEVA: CatalogueCategory[] = [
  {id:"mov",icon:"🚜",label:"Movimiento de tierras",color:"#FB923C",items:[
    {id:"mv1",cod:"MOV001",label:"Desbroce y limpieza del terreno",ud:"m²",p:3},
    {id:"mv2",cod:"MOV002",label:"Excavación mecánica vaciado",ud:"m³",p:18},
    {id:"mv3",cod:"MOV003",label:"Excavación zanjas cimentación",ud:"m³",p:22},
    {id:"mv4",cod:"MOV004",label:"Excavación sótano/semisótano",ud:"m³",p:25},
    {id:"mv5",cod:"MOV005",label:"Relleno y compactación tierras",ud:"m³",p:14},
    {id:"mv6",cod:"MOV006",label:"Transporte y gestión tierras",ud:"m³",p:12},
    {id:"mv7",cod:"MOV007",label:"Nivelación y rasanteo",ud:"m²",p:5},
  ]},
  {id:"cim",icon:"⚓",label:"Cimentación y estructura",color:"#F87171",items:[
    {id:"ci1",cod:"CIM001",label:"Hormigón limpieza HL-150",ud:"m³",p:95},
    {id:"ci2",cod:"CIM002",label:"Zapata aislada HA-25",ud:"m³",p:185},
    {id:"ci3",cod:"CIM003",label:"Zapata corrida HA-25",ud:"m³",p:175},
    {id:"ci4",cod:"CIM004",label:"Losa de cimentación HA-25",ud:"m³",p:195},
    {id:"ci5",cod:"CIM005",label:"Viga de atado/centradora",ud:"m³",p:180},
    {id:"ci7",cod:"CIM007",label:"Muro sótano HA-25 e=25cm",ud:"m²",p:165},
    {id:"ci8",cod:"CIM008",label:"Pilar hormigón armado",ud:"m³",p:420},
    {id:"ci9",cod:"CIM009",label:"Viga hormigón armado",ud:"m³",p:380},
    {id:"ci10",cod:"CIM010",label:"Forjado unidireccional",ud:"m²",p:68},
    {id:"ci11",cod:"CIM011",label:"Forjado reticular",ud:"m²",p:75},
    {id:"ci12",cod:"CIM012",label:"Losa maciza HA-25 e=20cm",ud:"m²",p:85},
    {id:"ci13",cod:"CIM013",label:"Estructura metálica (kg)",ud:"kg",p:3.2},
    {id:"ci14",cod:"CIM014",label:"Escalera hormigón armado",ud:"ud",p:2800},
  ]},
  {id:"cer",icon:"🧱",label:"Cerramientos y cubierta",color:"#60A5FA",items:[
    {id:"ce1",cod:"CER001",label:"Fachada ladrillo cara vista",ud:"m²",p:95},
    {id:"ce2",cod:"CER002",label:"Fachada bloque de hormigón",ud:"m²",p:58},
    {id:"ce3",cod:"CER003",label:"Fachada ventilada panel+subestructura",ud:"m²",p:145},
    {id:"ce4",cod:"CER004",label:"Fachada SATE aislamiento exterior",ud:"m²",p:85},
    {id:"ce5",cod:"CER005",label:"Hoja interior fachada LH7",ud:"m²",p:35},
    {id:"ce6",cod:"CER006",label:"Cámara aire + aislamiento",ud:"m²",p:18},
    {id:"ce7",cod:"CER007",label:"Cubierta plana invertida",ud:"m²",p:85},
    {id:"ce8",cod:"CER008",label:"Cubierta inclinada teja cerámica",ud:"m²",p:95},
    {id:"ce9",cod:"CER009",label:"Cubierta panel sándwich/chapa",ud:"m²",p:55},
    {id:"ce10",cod:"CER010",label:"Cubierta verde/ajardinada",ud:"m²",p:145},
    {id:"ce11",cod:"CER011",label:"Impermeabilización cubierta plana",ud:"m²",p:35},
    {id:"ce12",cod:"CER012",label:"Lucernario/claraboya",ud:"ud",p:1800},
    {id:"ce13",cod:"CER013",label:"Tabiquería interior ladrillo 7cm",ud:"m²",p:42},
    {id:"ce14",cod:"CER014",label:"Tabiquería cartón-yeso simple",ud:"m²",p:38},
    {id:"ce15",cod:"CER015",label:"Tabiquería cartón-yeso doble",ud:"m²",p:52},
    {id:"ce16",cod:"CER016",label:"Aislamiento acústico entre plantas",ud:"m²",p:22},
  ]},
  {id:"car2",icon:"🚪",label:"Carpintería exterior e interior",color:"#34D399",items:[
    {id:"cp1",cod:"CAR101",label:"Ventana PVC/aluminio 1 hoja",ud:"ud",p:420},
    {id:"cp2",cod:"CAR102",label:"Ventana PVC/aluminio 2 hojas",ud:"ud",p:520},
    {id:"cp3",cod:"CAR103",label:"Balconera PVC/aluminio",ud:"ud",p:680},
    {id:"cp4",cod:"CAR104",label:"Puerta entrada principal blindada",ud:"ud",p:1400},
    {id:"cp5",cod:"CAR105",label:"Puerta interior paso",ud:"ud",p:320},
    {id:"cp6",cod:"CAR106",label:"Puerta corredera interior",ud:"ud",p:480},
    {id:"cp7",cod:"CAR107",label:"Puerta corredera cristal",ud:"ud",p:1100},
    {id:"cp8",cod:"CAR108",label:"Armario empotrado a medida",ud:"ml",p:280},
    {id:"cp9",cod:"CAR109",label:"Ventana de tejado tipo Velux",ud:"ud",p:950},
    {id:"cp10",cod:"CAR110",label:"Persiana motorizada",ud:"ud",p:380},
    {id:"cp11",cod:"CAR111",label:"Muro cortina/fachada vidrio",ud:"m²",p:480},
  ]},
  {id:"inst",icon:"🔧",label:"Instalaciones",color:"#38BDF8",items:[
    {id:"in1",cod:"INS001",label:"Red agua fría multicapa completa",ud:"ud",p:2800},
    {id:"in2",cod:"INS002",label:"Red agua caliente sanitaria",ud:"ud",p:1800},
    {id:"in3",cod:"INS003",label:"Red evacuación PVC completa",ud:"ud",p:2200},
    {id:"in4",cod:"INS004",label:"Acometida agua potable",ud:"ud",p:1800},
    {id:"in5",cod:"INS005",label:"Acometida gas",ud:"ud",p:1400},
    {id:"in6",cod:"INS006",label:"Acometida eléctrica BT",ud:"ud",p:2200},
    {id:"in7",cod:"INS007",label:"Cuadro general + subcuadros",ud:"ud",p:1800},
    {id:"in8",cod:"INS008",label:"Instalación eléctrica completa",ud:"m²",p:38},
    {id:"in9",cod:"INS009",label:"Telecomunicaciones ICT",ud:"ud",p:1200},
    {id:"in10",cod:"INS010",label:"Caldera condensación gas",ud:"ud",p:2800},
    {id:"in11",cod:"INS011",label:"Aerotermia ACS+calefacción",ud:"ud",p:6500},
    {id:"in12",cod:"INS012",label:"Suelo radiante hidráulico",ud:"m²",p:42},
    {id:"in13",cod:"INS013",label:"Sistema splits/climatización",ud:"ud",p:3200},
    {id:"in14",cod:"INS014",label:"Ventilación mecánica VMC",ud:"ud",p:2800},
    {id:"in15",cod:"INS015",label:"Solar fotovoltaica",ud:"kWp",p:1400},
    {id:"in16",cod:"INS016",label:"Solar térmica ACS",ud:"ud",p:3800},
    {id:"in17",cod:"INS017",label:"Domótica KNX/Z-Wave",ud:"ud",p:3500},
    {id:"in18",cod:"INS018",label:"Punto recarga VE",ud:"ud",p:1200},
    {id:"in19",cod:"INS019",label:"Pararrayos",ud:"ud",p:1800},
    {id:"in20",cod:"INS020",label:"Detección incendios",ud:"ud",p:2200},
  ]},
  {id:"ban2",icon:"🚿",label:"Baños y cocinas",color:"#A78BFA",items:[
    {id:"bn1",cod:"BAK001",label:"Baño completo equipado",ud:"ud",p:3200},
    {id:"bn2",cod:"BAK002",label:"Aseo completo equipado",ud:"ud",p:1800},
    {id:"bn3",cod:"BAK003",label:"Cocina equipada media calidad",ud:"ml",p:850},
    {id:"bn4",cod:"BAK004",label:"Cocina equipada alta calidad",ud:"ml",p:1400},
    {id:"bn5",cod:"BAK005",label:"Inodoro suspendido + cisterna",ud:"ud",p:680},
    {id:"bn6",cod:"BAK006",label:"Plato ducha obra + mampara",ud:"ud",p:1200},
    {id:"bn7",cod:"BAK007",label:"Bañera acrílica",ud:"ud",p:520},
    {id:"bn8",cod:"BAK008",label:"Lavabo + mueble + espejo",ud:"ud",p:780},
    {id:"bn9",cod:"BAK009",label:"Fregadero cocina + grifería",ud:"ud",p:320},
  ]},
  {id:"aca2",icon:"🎨",label:"Acabados interiores",color:"#FBBF24",items:[
    {id:"ac1",cod:"ACN001",label:"Pavimento tarima flotante",ud:"m²",p:38},
    {id:"ac2",cod:"ACN002",label:"Pavimento baldosa gres porcelánico",ud:"m²",p:45},
    {id:"ac3",cod:"ACN003",label:"Pavimento microcemento",ud:"m²",p:85},
    {id:"ac4",cod:"ACN004",label:"Pavimento mármol/piedra",ud:"m²",p:120},
    {id:"ac5",cod:"ACN005",label:"Alicatado baños/cocinas",ud:"m²",p:42},
    {id:"ac6",cod:"ACN006",label:"Pintura paredes+techo",ud:"m²",p:9},
    {id:"ac7",cod:"ACN007",label:"Falso techo cartón-yeso",ud:"m²",p:48},
    {id:"ac8",cod:"ACN008",label:"Rodapiés",ud:"ml",p:14},
    {id:"ac9",cod:"ACN009",label:"Yeso/enlucido fachada interior",ud:"m²",p:18},
    {id:"ac11",cod:"ACN011",label:"Nivelación suelo autonivelante",ud:"m²",p:8},
  ]},
];

// ── EXTERIOR (127 items) ──────────────────────────────────────────
export const CATS_EXTERIOR: CatalogueCategory[] = [
  {id:"mov2",icon:"🚜",label:"Movimiento de tierras",color:"#FB923C",items:[
    {id:"xm1",cod:"EXT001",label:"Desbroce y limpieza parcela",ud:"m²",p:3},
    {id:"xm2",cod:"EXT002",label:"Excavación mecánica",ud:"m³",p:18},
    {id:"xm3",cod:"EXT003",label:"Relleno y compactación",ud:"m³",p:14},
    {id:"xm4",cod:"EXT004",label:"Nivelación y rasanteo",ud:"m²",p:5},
    {id:"xm5",cod:"EXT005",label:"Transporte de tierras",ud:"m³",p:12},
  ]},
  {id:"val",icon:"🚧",label:"Vallas y cerramientos",color:"#F87171",items:[
    {id:"v1",cod:"VAL001",label:"Muro cerramiento ladrillo",ud:"m²",p:95},
    {id:"v2",cod:"VAL002",label:"Muro cerramiento bloque hormigón",ud:"m²",p:62},
    {id:"v3",cod:"VAL003",label:"Muro mampostería/piedra",ud:"m²",p:145},
    {id:"v4",cod:"VAL004",label:"Valla metálica tubular galvanizada",ud:"ml",p:85},
    {id:"v5",cod:"VAL005",label:"Valla metálica lacada/pintada",ud:"ml",p:110},
    {id:"v6",cod:"VAL006",label:"Celosía metálica decorativa",ud:"m²",p:145},
    {id:"v7",cod:"VAL007",label:"Cerramiento acero cortén",ud:"m²",p:185},
    {id:"v8",cod:"VAL008",label:"Panel hormigón prefabricado",ud:"m²",p:75},
    {id:"v9",cod:"VAL009",label:"Malla electrosoldada",ud:"ml",p:28},
    {id:"v10",cod:"VAL010",label:"Cerramiento madera/composite",ud:"ml",p:95},
    {id:"v11",cod:"VAL011",label:"Seto/muro vegetal artificial",ud:"m²",p:65},
    {id:"v12",cod:"VAL012",label:"Cimentación y pilares valla",ud:"ml",p:45},
    {id:"v13",cod:"VAL013",label:"Zócalo de hormigón valla",ud:"ml",p:38},
  ]},
  {id:"pta",icon:"🚗",label:"Puertas y accesos",color:"#34D399",items:[
    {id:"p1",cod:"PTA001",label:"Puerta peatonal abatible acero",ud:"ud",p:850},
    {id:"p2",cod:"PTA002",label:"Puerta peatonal corredera acero",ud:"ud",p:1100},
    {id:"p3",cod:"PTA003",label:"Puerta peatonal acero cortén",ud:"ud",p:1400},
    {id:"p4",cod:"PTA004",label:"Puerta garaje basculante",ud:"ud",p:1200},
    {id:"p5",cod:"PTA005",label:"Puerta garaje seccional motorizada",ud:"ud",p:1800},
    {id:"p6",cod:"PTA006",label:"Puerta garaje corredera motorizada",ud:"ud",p:2200},
    {id:"p7",cod:"PTA007",label:"Barrera de acceso motorizada",ud:"ud",p:2800},
    {id:"p8",cod:"PTA008",label:"Puerta corredera gran formato >4m",ud:"ud",p:3500},
    {id:"p9",cod:"PTA009",label:"Control de acceso lector+interfono",ud:"ud",p:1200},
    {id:"p10",cod:"PTA010",label:"Videoportero exterior",ud:"ud",p:680},
    {id:"p11",cod:"PTA011",label:"Automatización puerta existente",ud:"ud",p:580},
  ]},
  {id:"pav",icon:"🏗️",label:"Pavimentos exteriores",color:"#FBBF24",items:[
    {id:"pv1",cod:"PAV001",label:"Solera hormigón e=10cm",ud:"m²",p:22},
    {id:"pv2",cod:"PAV002",label:"Solera hormigón impreso/estampado",ud:"m²",p:45},
    {id:"pv3",cod:"PAV003",label:"Baldosa exterior antideslizante",ud:"m²",p:48},
    {id:"pv4",cod:"PAV004",label:"Tarima exterior composite/madera",ud:"m²",p:85},
    {id:"pv5",cod:"PAV005",label:"Adoquín hormigón/granito",ud:"m²",p:55},
    {id:"pv6",cod:"PAV006",label:"Gravilla/árido decorativo",ud:"m²",p:12},
    {id:"pv7",cod:"PAV007",label:"Pavimento poroso/drenante",ud:"m²",p:38},
    {id:"pv8",cod:"PAV008",label:"Camino/sendero exterior",ud:"ml",p:45},
    {id:"pv9",cod:"PAV009",label:"Rampa acceso hormigón",ud:"m²",p:55},
    {id:"pv10",cod:"PAV010",label:"Base y sub-base compactada",ud:"m²",p:12},
  ]},
  {id:"pis",icon:"🏊",label:"Piscinas y spas",color:"#38BDF8",items:[
    {id:"ps1",cod:"PIS001",label:"Piscina obra estándar 8x4m",ud:"ud",p:28000},
    {id:"ps2",cod:"PIS002",label:"Piscina obra a medida",ud:"m²",p:850},
    {id:"ps3",cod:"PIS003",label:"Piscina prefabricada fibra",ud:"ud",p:18000},
    {id:"ps4",cod:"PIS004",label:"Piscina liner/acero inoxidable",ud:"m²",p:650},
    {id:"ps5",cod:"PIS005",label:"Gresite/azulejo revestimiento",ud:"m²",p:65},
    {id:"ps6",cod:"PIS006",label:"Sistema filtración completo",ud:"ud",p:2800},
    {id:"ps7",cod:"PIS007",label:"Bomba de calor piscina",ud:"ud",p:3200},
    {id:"ps8",cod:"PIS008",label:"Cobertor/cubierta piscina",ud:"ud",p:2200},
    {id:"ps9",cod:"PIS009",label:"Escalera acero inoxidable",ud:"ud",p:480},
    {id:"ps10",cod:"PIS010",label:"Iluminación LED piscina",ud:"ud",p:380},
    {id:"ps11",cod:"PIS011",label:"Cuarto de máquinas",ud:"ud",p:3500},
    {id:"ps12",cod:"PIS012",label:"Ducha exterior piscina",ud:"ud",p:280},
    {id:"ps13",cod:"PIS013",label:"Playa/andén hormigón",ud:"m²",p:55},
    {id:"ps14",cod:"PIS014",label:"Jacuzzi/spa exterior",ud:"ud",p:12000},
  ]},
  {id:"jar",icon:"🌿",label:"Jardinería",color:"#3FB950",items:[
    {id:"j1",cod:"JAR001",label:"Preparación tierra vegetal+abonado",ud:"m²",p:8},
    {id:"j2",cod:"JAR002",label:"Césped natural siembra",ud:"m²",p:6},
    {id:"j3",cod:"JAR003",label:"Césped natural en rollo",ud:"m²",p:14},
    {id:"j4",cod:"JAR004",label:"Césped artificial",ud:"m²",p:35},
    {id:"j5",cod:"JAR005",label:"Árbol mediano suministro+plantación",ud:"ud",p:280},
    {id:"j6",cod:"JAR006",label:"Arbusto/seto suministro+plantación",ud:"ud",p:45},
    {id:"j7",cod:"JAR007",label:"Planta tapizante/cubresuelos",ud:"m²",p:12},
    {id:"j8",cod:"JAR008",label:"Sistema riego automático",ud:"m²",p:8},
    {id:"j9",cod:"JAR009",label:"Arqueta y electroválvula riego",ud:"ud",p:180},
    {id:"j10",cod:"JAR010",label:"Bordillo hormigón/acero corten",ud:"ml",p:22},
    {id:"j11",cod:"JAR011",label:"Pérgola madera/aluminio",ud:"m²",p:185},
    {id:"j12",cod:"JAR012",label:"Pérgola bioclimática motorizada",ud:"m²",p:380},
    {id:"j13",cod:"JAR013",label:"Caseta jardín/almacén",ud:"ud",p:2800},
    {id:"j14",cod:"JAR014",label:"Bancal/jardinera de obra",ud:"ml",p:95},
    {id:"j15",cod:"JAR015",label:"Estanque/lámina de agua",ud:"ud",p:3500},
    {id:"j16",cod:"JAR016",label:"Jardinera de obra hormigón/ladrillo",ud:"ml",p:145},
    {id:"j17",cod:"JAR017",label:"Jardinera prefabricada hormigón",ud:"ud",p:380},
    {id:"j18",cod:"JAR018",label:"Bancal elevado huerto urbano",ud:"ml",p:185},
    {id:"j19",cod:"JAR019",label:"Macetero/tiesto gran formato",ud:"ud",p:220},
    {id:"j20",cod:"JAR020",label:"Zona de juegos infantil exterior",ud:"ud",p:2800},
    {id:"j21",cod:"JAR021",label:"Columpio/tobogán madera tratada",ud:"ud",p:1200},
  ]},
  {id:"bbq",icon:"🔥",label:"Barbacoas y zonas de ocio",color:"#FB923C",items:[
    {id:"bq1",cod:"BBQ001",label:"Barbacoa de obra ladrillo/bloque",ud:"ud",p:1800},
    {id:"bq2",cod:"BBQ002",label:"Barbacoa de obra con encimera",ud:"ud",p:2800},
    {id:"bq3",cod:"BBQ003",label:"Barbacoa acero inox prefabricada",ud:"ud",p:1200},
    {id:"bq4",cod:"BBQ004",label:"Horno de leña exterior",ud:"ud",p:2400},
    {id:"bq5",cod:"BBQ005",label:"Cocina exterior equipada completa",ud:"ud",p:4500},
    {id:"bq6",cod:"BBQ006",label:"Módulo cocina exterior acero",ud:"ml",p:1800},
    {id:"bq7",cod:"BBQ007",label:"Fregadero exterior acero inox",ud:"ud",p:380},
    {id:"bq8",cod:"BBQ008",label:"Encimera exterior compacto/granito",ud:"ml",p:320},
    {id:"bq9",cod:"BBQ009",label:"Pérgola/porche cubierto zona BBQ",ud:"m²",p:280},
    {id:"bq10",cod:"BBQ010",label:"Mesa y banco de obra",ud:"ud",p:850},
    {id:"bq11",cod:"BBQ011",label:"Chimenea exterior",ud:"ud",p:1600},
    {id:"bq12",cod:"BBQ012",label:"Conexión gas exterior BBQ",ud:"ud",p:480},
    {id:"bq13",cod:"BBQ013",label:"Punto agua+desagüe exterior",ud:"ud",p:320},
    {id:"bq14",cod:"BBQ014",label:"Solado zona BBQ hormigón/baldosa",ud:"m²",p:48},
    {id:"bq15",cod:"BBQ015",label:"Zona chill-out con pavimento",ud:"m²",p:65},
    {id:"bq16",cod:"BBQ016",label:"Pérgola bioclimática zona ocio",ud:"m²",p:380},
  ]},
  {id:"ilu",icon:"💡",label:"Iluminación exterior",color:"#FCD34D",items:[
    {id:"il1",cod:"ILU001",label:"Farola/luminaria LED vial",ud:"ud",p:480},
    {id:"il2",cod:"ILU002",label:"Baliza jardín LED",ud:"ud",p:180},
    {id:"il3",cod:"ILU003",label:"Proyector LED fachada/jardín",ud:"ud",p:220},
    {id:"il4",cod:"ILU004",label:"Tira LED empotrada suelo",ud:"ml",p:65},
    {id:"il5",cod:"ILU005",label:"Luminaria empotrada suelo",ud:"ud",p:145},
    {id:"il6",cod:"ILU006",label:"Cableado exterior tubo+cable",ud:"ml",p:8},
    {id:"il7",cod:"ILU007",label:"Cuadro maniobra exterior",ud:"ud",p:680},
    {id:"il8",cod:"ILU008",label:"Sensor crepuscular/temporizador",ud:"ud",p:120},
    {id:"il9",cod:"ILU009",label:"Detector movimiento exterior",ud:"ud",p:85},
  ]},
  {id:"dra",icon:"🌊",label:"Drenaje y acometidas",color:"#60A5FA",items:[
    {id:"dr1",cod:"DRA001",label:"Acometida agua potable",ud:"ud",p:2200},
    {id:"dr2",cod:"DRA002",label:"Acometida eléctrica BT",ud:"ud",p:2800},
    {id:"dr3",cod:"DRA003",label:"Acometida gas",ud:"ud",p:1800},
    {id:"dr4",cod:"DRA004",label:"Acometida telecomunicaciones",ud:"ud",p:1200},
    {id:"dr5",cod:"DRA005",label:"Red pluviales exterior",ud:"ml",p:28},
    {id:"dr6",cod:"DRA006",label:"Canaleta/sumidero lineal",ud:"ml",p:45},
    {id:"dr7",cod:"DRA007",label:"Arqueta sifónica/registro",ud:"ud",p:120},
    {id:"dr8",cod:"DRA008",label:"Pozo de drenaje",ud:"ud",p:680},
    {id:"dr9",cod:"DRA009",label:"Depósito aguas pluviales",ud:"ud",p:2200},
    {id:"dr10",cod:"DRA010",label:"Fosa séptica",ud:"ud",p:3800},
    {id:"dr11",cod:"DRA011",label:"Tubería drenaje perforada",ud:"ml",p:18},
    {id:"dr12",cod:"DRA012",label:"Bajante exterior PVC",ud:"ml",p:22},
  ]},
];
